import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes';

import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { INLINE_MESSAGE_TYPES } from 'ui-components/components/inline-message';
import { Input, version2 } from 'ui-components/components/input';

import { RowsDataContext } from '..';
import { FIELD_NAMES } from '../../../constants';
import style from '../invite-vendor-modal.module.less';
import { messages } from '../messages';

export const TableRow = ({ deleteTableRows, handleChange }) => {
  const rowsData = useContext(RowsDataContext);

  const showDeleteRowButton = rowsData.length > 1;

  const getInlineMessage = (row, name) => {
    if (name === FIELD_NAMES.VENDOR_NICKNAME) {
      if (row.emptyNickname) {
        return <FormattedMessage {...messages.emptyNicknameError} />;
      }
      if (row.duplicateNickname) {
        return <FormattedMessage {...messages.duplicateNicknameError} />;
      }
      return null;
    }
    if (name === FIELD_NAMES.EMAIL_ADDRESS) {
      if (row.invalidEmail) {
        return <FormattedMessage {...messages.invalidEmailError} />;
      }
      if (row.duplicateEmail) {
        return <FormattedMessage {...messages.duplicateEmailError} />;
      }
      return null;
    }
  };

  return rowsData.map((data, index) => {
    const { vendorNickname, emailAddress } = data;
    return (
      <tr key={index} className={style['table-rows']}>
        <td>
          <Input
            className={style['nickname-input']}
            inlineMessage={getInlineMessage(data, FIELD_NAMES.VENDOR_NICKNAME)}
            inlineMessageType={INLINE_MESSAGE_TYPES.error}
            name={FIELD_NAMES.VENDOR_NICKNAME}
            onChange={(evnt) => {
              handleChange(index, evnt.target.value, FIELD_NAMES.VENDOR_NICKNAME);
            }}
            type='text'
            value={vendorNickname}
            version={version2}
          />
        </td>
        <td>
          <Input
            className={style['email-input']}
            inlineMessage={getInlineMessage(data, FIELD_NAMES.EMAIL_ADDRESS)}
            inlineMessageType={INLINE_MESSAGE_TYPES.error}
            name={FIELD_NAMES.EMAIL_ADDRESS}
            onChange={(evnt) => {
              handleChange(index, evnt.target.value, FIELD_NAMES.EMAIL_ADDRESS);
            }}
            type='text'
            value={emailAddress}
            version={version2}
          />
        </td>
        {showDeleteRowButton ? (
          <td className={style['delete-button-container']}>
            <Button
              onClick={() => {
                deleteTableRows(index);
              }}
              theme='link'
            >
              <FontAwesomeIcon className={style['delete-icon']} icon={faTimes} />
            </Button>
          </td>
        ) : null}
      </tr>
    );
  });
};
